export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7943.2ae18e5e.jpg";